import { render, staticRenderFns } from "./FlipCardToolbar.vue?vue&type=template&id=dc2a4d32"
import script from "./FlipCardToolbar.vue?vue&type=script&lang=js"
export * from "./FlipCardToolbar.vue?vue&type=script&lang=js"
import style0 from "./FlipCardToolbar.vue?vue&type=style&index=0&id=dc2a4d32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports